import React from "react";
import { MenuLink } from "../../atoms/menu/link";
import { Flex } from "rebass/styled-components";
import styled from "styled-components";

const DropdownContainer = styled(Flex)`
  font-size: ${(props) => props.theme.text.body.fontSize};
  white-space: nowrap;
  flex-direction: column;
`;

export function SideFooterDropdown(props) {
  return (
    <DropdownContainer className={props.className}>
      <MenuLink to="/feature/allstarstudio">What is Studio?</MenuLink>
      <MenuLink to="/feature/montages">What are Montages?</MenuLink>
      <MenuLink
        href="https://allstar.canny.io/feature-requests?category=new-games&sort=top"
        onClick={() => {
          window.location =
            "https://allstar.canny.io/feature-requests?category=new-games&sort=top";
        }}
      >
        Feature Requests
      </MenuLink>
      <MenuLink
        href="https://allstar.canny.io/feature-requests?category=new-games&sort=top"
        onClick={() => {
          window.location =
            "https://allstar.canny.io/feature-requests?category=new-games&sort=top";
        }}
      >
        Game Requests
      </MenuLink>
      <MenuLink to="/faq">FAQ</MenuLink>
      <MenuLink to="/legal/do-not-sell-my-personal-information">
        Do not sell my personal information
      </MenuLink>
    </DropdownContainer>
  );
}
